import { useId } from "react";
import "./usendMarks.css";

export const BOX = "M60 12 L102 36 L102 84 L60 108 L18 84 L18 36 Z";
export const U =
  "M73.86 17.04 L29.34 42.48 L29.34 71.28 L29.42 72.78 L29.67 74.35 L30.08 75.96 L30.63 77.59 L31.34 79.20 L32.17 80.77 L33.12 82.27 L34.17 83.68 L35.30 84.97 L36.50 86.12 L37.74 87.12 L39.00 87.93 L40.26 88.56 L41.50 88.98 L42.70 89.20 L43.83 89.20 L44.88 88.99 L45.83 88.57 L46.66 87.96 L47.37 87.15 L47.92 86.16 L48.33 85.01 L48.58 83.73 L48.66 82.32 L48.66 53.52 L93.18 28.08";

export function Gradient({ id }) {
  return (
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#8348FF" />
        <stop offset="1" stopColor="#318BFF" />
      </linearGradient>
    </defs>
  );
}

// The U-Send mark with a light running through the U, for anything that is loading.
export function UsendLoadingMark({ size = 24 }) {
  const id = `usend-loading-${useId().replace(/:/g, "")}`;
  return (
    <svg className="usend-mark" width={size} height={size} viewBox="0 0 120 120" aria-hidden="true">
      <Gradient id={id} />
      <path d={BOX} fill={`url(#${id})`} />
      <path d={U} fill="none" stroke="#FFFFFF" strokeOpacity="0.35" strokeWidth="8" strokeLinejoin="round" />
      <path className="usend-mark__run" pathLength="100" d={U} fill="none" stroke="#FFFFFF" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// The U turns into a tick once, for something that just finished.
export function UsendDoneMark({ size = 24 }) {
  const id = `usend-done-${useId().replace(/:/g, "")}`;
  return (
    <svg className="usend-done" width={size} height={size} viewBox="0 0 120 120" style={{ overflow: "visible" }} aria-hidden="true">
      <Gradient id={id} />
      <path className="usend-done__ring" d={BOX} fill="none" stroke="#7B6BFF" strokeWidth="6" strokeLinejoin="round" />
      <g className="usend-done__box">
        <path d={BOX} fill={`url(#${id})`} />
        <path className="usend-done__u" pathLength="100" d={U} fill="none" stroke="#FFFFFF" strokeWidth="8" strokeLinejoin="round" />
        <path className="usend-done__tick" pathLength="100" d="M45 61 L56 72 L77 50" fill="none" stroke="#FFFFFF" strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

// The plain U-Send mark, for logos.
export function UsendMark({ size = 24, stroke = 8 }) {
  const id = `usend-mark-${useId().replace(/:/g, "")}`;
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" aria-hidden="true">
      <Gradient id={id} />
      <path d={BOX} fill={`url(#${id})`} />
      <path d={U} fill="none" stroke="#FFFFFF" strokeWidth={stroke} strokeLinejoin="round" />
    </svg>
  );
}
